import React, { PropsWithChildren } from 'react';

import Button from '@/core/components/Button';
import Icons from '@/core/components/Icons';
import { InterestsModal } from '@/core/components/InterestsForm/InterestsModal';
import { ProfileTitle } from '@/core/components/ProfileDetails/components';
import useDisclosure from '@/core/hooks/useDisclosure';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const UserInterestsSection: React.FC<{ interests?: string[]; isSmall?: boolean }> = ({ interests, isSmall }) => {
  const { t } = useTranslationContext(['common']);
  const manageInterests = useDisclosure();

  const hasInterest = !!interests?.length;

  return (
    <>
      <section className="space-y-2 lg:space-y-3">
        <ProfileTitle tag="h2" isSmall={isSmall}>
          <div className="flex gap-1">
            <span>{t('components.profile.public.interests-title', { ns: 'common' })}</span>
            {hasInterest && (
              <Button
                variant="ghost"
                size="small"
                isInline
                onClick={e => {
                  e.preventDefault();
                  manageInterests.onOpen();
                }}
              >
                <Icons icon="edit" color="brand" />
              </Button>
            )}
          </div>
        </ProfileTitle>
        <div className="flex flex-wrap gap-2">
          {hasInterest ? (
            interests.map(interest => <InterestTag key={interest}>{t(`thematiques.${interest}.title`, { ns: 'common' })}</InterestTag>)
          ) : (
            <Button
              variant="secondary"
              size="medium"
              isInline
              iconLeft="add"
              onClick={e => {
                e.preventDefault();
                manageInterests.onOpen();
              }}
            >
              {t('components.profile.public.interests-add', { ns: 'common' })}
            </Button>
          )}
        </div>
      </section>
      {manageInterests.isOpen && <InterestsModal isOpen onClose={manageInterests.onClose} />}
    </>
  );
};

const InterestTag: React.FC<PropsWithChildren> = ({ children }) => <span className="text-caption-primary block rounded-1 bg-bg-tag-status-booked p-1 text-content-secondary">{children}</span>;
